import { render } from "./HiViewError.vue?vue&type=template&id=c07366e6"
import script from "./HiViewError.vue?vue&type=script&lang=js"
export * from "./HiViewError.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__